var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"religiao","rota-base":"/admin/religiao","titulo-singular":"Religião","campos-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }